import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';
import showInstallModal from '@/ui/modals/install-modal';

const usePromptInstall = () => {
  const modalVisible = useSelector(selectors.pwa.installModalVisible);

  useEffect(() => {
    if (!modalVisible) {
      return;
    }

    showInstallModal();
  }, [modalVisible]);
};

export default usePromptInstall;
